var breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1330,
    match: function (bp) {
        return window.matchMedia("screen and (min-width: " + bp + "px)").matches;
    },
    addListener: function (bp, func) {
        window.matchMedia("screen and (min-width: " + bp + "px)").addListener(function () {
            func();
        });
    }
};
